module.exports = __webpack_public_path__ + "static/media/cor_2020.47e993b7.doc";